// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BulkselectionController from "./bulkselection_controller"
application.register("bulkselection", BulkselectionController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DualCheckboxController from "./dual_checkbox_controller"
application.register("dual-checkbox", DualCheckboxController)

import NavmenuController from "./navmenu_controller"
application.register("navmenu", NavmenuController)

import CompositeSelectFieldController from "./composite_select_field_controller"
application.register("composite-select-field", CompositeSelectFieldController)

import HwComboboxController from "@josefarias/hotwire_combobox"
application.register("hw-combobox", HwComboboxController)
